import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from "react-redux";

import { Grid, Box, Button, IconButton, Typography, Checkbox, ListItemText, FormControlLabel, ButtonGroup } from '@mui/material';
import Modal from '@mui/material/Modal';
import TuneIcon from '@mui/icons-material/Tune';
import Radio from '@mui/material/Radio';

import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import { makeStyles } from '@material-ui/core/styles';

import { getByMonth, currentMonth } from "../../Js/TimeAndDate";
import FormControl from '@mui/material/FormControl';
import WwDatePicker from "./WwDatePicker";
import Slide from '@mui/material/Slide';
import { grey } from '@mui/material/colors';

const monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const WwDateFilterModal = (props) => {

    // Redux state
    const containerRef = useRef();
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
    const classes = useStyles();

    const [modalVisible, setModalVisible] = useState(false);
    const [month, setMonth] = useState(null);
    const [monthName, setMonthName] = useState('');

    const [commences, setCommences] = useState(null);
    const [expiries, setExpiries] = useState(null);

    const [endMinDate, setEndMinDate] = useState(Date.now());
    const [errorStartDate, setErrorStartDate] = useState(null);
    const [errorEndDate, setErrorEndDate] = useState(null);

    const [selectedRadioValue, setSelectedRadioValue] = useState('month');

    

    useEffect(() => {
        let currentDate = new Date();
        setMonth(currentDate.getMonth());
        setMonthName(monthArr[currentDate.getMonth()]);

        let objCurrentMonth = currentMonth('YYYY-MM-DD');
        setCommences(objCurrentMonth.startOfMonth);
        setExpiries(objCurrentMonth.endOfMonth);
    }, []);

    // const handleOpen = () => setModalVisible(true);
    const handleClose = () => setModalVisible(false);

    const handleRadioChange = (event) => {
        setSelectedRadioValue(event.target.value);
    };

    // Date change
    const DateChange = (date, valid, err, field) => {
        if (valid) {
            if (field === "startdate") {
                let endMinTime = new Date(date);
                setCommences(date);
                setEndMinDate(endMinTime.getTime());
                setErrorStartDate(null);
            }
            if (field === "enddate") {
                setExpiries(date);
                setErrorEndDate(null);
            }
        } else {
            setTimeout(() => {
                if (field === "startdate") {
                    setCommences(null);
                    setErrorStartDate(err);
                }
                if (field === "enddate") {
                    setExpiries(null);
                    setErrorEndDate(err);
                }
            }, 500);
        }
    };

    const getPrevMonth = () => {
        if (month === 0) return;
        let selMon = month - 1;
        setMonth(selMon);
        setMonthName(monthArr[selMon]);
    };

    const getNextMonth = () => {
        let currentDate = new Date();
        if (month >= currentDate.getMonth() || month === 11) return;
        let selMon = month + 1;
        setMonth(selMon);
        setMonthName(monthArr[selMon]);
    };

    const handleFilter = () => {
        if (selectedRadioValue === 'month') {
          let objCurrentMonth = getByMonth(month, 'YYYY-MM-DD');
          let startDt = objCurrentMonth.startOfMonth;
          let endDt = objCurrentMonth.endOfMonth;
          props.press({            
            "start_date": startDt,
            "end_date": endDt
          });
        } else {
          props.press({            
            "start_date": commences,
            "end_date": expiries
          });
        }
        handleClose();
      };

    const resetState = () => {
        setCommences(null);
        setExpiries(null);
        setErrorStartDate(null);
        setErrorEndDate(null);
        setSelectedRadioValue('month');        
    }

    return (
        <div>            
            <Modal
                open={props.visible}
                onClose={() => {
                    if (!props.persistent) {
                        props.toggleModal(false);
                    }
                }}
                ref={containerRef}
                sx={{border: "0px !important", display: 'flex',
                    justifyContent: 'center', alignItems: 'center'}}
            >
                <Slide direction="up" in={props.visible} container={containerRef.current}>
                    <Box className={classes.Modal}>
                        <Grid container style={{ gap: 1, justifyContent: 'space-between' }}>
                            <Grid item xs={3} ml={1}>
                                <FormControlLabel
                                    control={
                                        <Radio
                                            checked={selectedRadioValue === 'month'}
                                            value='month'
                                            onChange={handleRadioChange}
                                            sx={{
                                                color: grey[50],
                                                '&.Mui-checked': {
                                                    color: grey[50],
                                                }
                                            }}
                                        />
                                    }
                                    label={<Typography color="#FFFFFF" sx={{
                                        fontSize: '0.9rem', fontWeight: '500', '@media (min-width: 1636px)': {
                                            fontSize: '1.4rem', my: 1
                                        }
                                    }}>Month</Typography>}
                                    sx={{ color: "#FFFFFF" }}
                                />
                            </Grid>
                            <Grid item xs={5}>
                                <ButtonGroup
                                    disableElevation
                                >
                                    <IconButton onClick={getPrevMonth}>
                                        <KeyboardDoubleArrowLeftIcon sx={{
                                            fontSize: '2rem', color: '#FFFFFF', '@media (min-width: 1636px)': {
                                                fontSize: '2.4rem'
                                            }
                                        }} />
                                    </IconButton>
                                    <Typography sx={{
                                        fontSize: '1rem', fontWeight: '600', pt: 1, borderRight: 0, color: '#FFFFFF', '@media (min-width: 1636px)': {
                                            fontSize: '1.4rem'
                                        }
                                    }}>{monthName}</Typography>
                                    <IconButton onClick={getNextMonth}>
                                        <KeyboardDoubleArrowRightIcon sx={{
                                            fontSize: '2rem', color: '#FFFFFF', '@media (min-width: 1636px)': {
                                                fontSize: '2.4rem'
                                            }
                                        }} />
                                    </IconButton>
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                        <Grid item xs={3} ml={1}>
                            <FormControlLabel
                                control={
                                    <Radio
                                        checked={selectedRadioValue === 'range'}
                                        value='range'
                                        onChange={handleRadioChange}
                                        sx={{
                                            color: grey[50],
                                            '&.Mui-checked': {
                                                color: grey[50],
                                            }
                                        }}
                                    />
                                }
                                label={<Typography color="#FFFFFF" sx={{
                                    fontSize: '0.9rem', fontWeight: '500', '@media (min-width: 1636px)': {
                                        fontSize: '1.4rem', my: 1
                                    }
                                }}>Range</Typography>}
                                sx={{ color: "#FFFFFF" }}
                            />
                        </Grid>
                        <Grid container sx={{}}>
                            <Grid item xs={6} sx={{ px: 1 }}>
                                <WwDatePicker
                                    dateChange={({ date, valid, errorMessage }) =>
                                        DateChange(date, valid, errorMessage, "startdate")
                                    }
                                    maxDate={Date.now()}
                                    defaultDate={commences}
                                ></WwDatePicker>
                            </Grid>
                            <Grid item xs={6} sx={{ px: 1 }}>
                                <WwDatePicker
                                    dateChange={({ date, valid, errorMessage }) =>
                                        DateChange(date, valid, errorMessage, "enddate")
                                    }
                                    minDate={endMinDate}
                                    defaultDate={expiries}
                                ></WwDatePicker>
                            </Grid>
                            {errorStartDate &&
                                <Grid>
                                    <Typography className={classes.errorMessage}>{errorStartDate}</Typography>
                                </Grid>
                            }
                            {errorEndDate &&
                                <Grid>
                                    <Typography className={classes.errorMessage}>{errorEndDate}</Typography>
                                </Grid>
                            }
                        </Grid>
                        <Box sx={{ my: 3, mx: 4 }}>                            
                            <Button
                                variant="standard"
                                fullWidth                                
                                sx={{
                                    color: "#FFFFFF",
                                    fontSize: "1.2rem",
                                    fontWeight: "700",
                                    border: 1,
                                    borderColor: "#FFFFFF",
                                    borderRadius: 10,
                                    
                                }}
                                onClick={handleFilter}
                            >
                                Apply
                            </Button>
                        </Box>
                        <Box sx={{ mx: 4 }}>
                            <Button
                                variant="standard"
                                fullWidth
                                sx={{
                                    color: "#FFFFFF",
                                    fontSize: "1.2rem",
                                    fontWeight: "700",
                                    border: 1,
                                    borderColor: "#FFFFFF",
                                    borderRadius: 10,
                                   
                                }}
                                onClick={resetState}
                            >
                                Reset
                            </Button>
                        </Box>
                    </Box>
                </Slide>
            </Modal>
        </div>
    );
};
const useStyles = makeStyles({
    Modal: {
        width: 400,
        backgroundColor: '#DB8829',
        boxShadow: 24,
        color: '#FFFFFF',
        borderRadius: 30,
        padding: 20,
    },
    errorMessage: {
        backgroundColor: 'red',
        color: '#FFFFFF',
        borderRadius: 30,
        padding: '10px 20px',
    },
})
export default WwDateFilterModal;